import { render } from "./AdminBannersView.vue?vue&type=template&id=9cc10894&scoped=true"
import script from "./AdminBannersView.vue?vue&type=script&lang=js"
export * from "./AdminBannersView.vue?vue&type=script&lang=js"

import "./AdminBannersView.vue?vue&type=style&index=0&id=9cc10894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc10894"]])

export default __exports__